export const PROGRESSBAR_MARGIN = 12
export const TOOLTIP_WIDTH = 72
